import { $el, $prependTo, $appendTo, $addClass } from 'fxdom/es';
import { UtilS } from '../../../../Util/S/Function/module/UtilS.js';
import { MShopUtilTmplS } from '../../S/Tmpl/module/MShopUtilTmplS.js';
import { createPopToastMsgForMarppleShop } from './createPopToastMsgForMarppleShop.js';
import { initToastContainer } from './initToastContainer.js';
import { ToastConfig } from './toast.config.ts';

const end_class = ToastConfig.endClass;
const toast_message_types = ToastConfig.types;
let toast_container_el;

const checkToastMessageType = (type) => {
  if (!toast_message_types.includes(type)) throw new Error('토스트 메세지 타입이 올바르지 않습니다.');
};

export const createToastMsg = (type, inner, opt = {}) => {
  checkToastMessageType(type);

  return $el(
    UtilS.isNessApp()
      ? MShopUtilTmplS.createNessToastItem(inner, { type, ...opt })
      : MShopUtilTmplS.createToastItem(inner, { type }),
  );
};

export const popToastMsg = (input_el, type, opt = {}) => {
  if (UtilS.isNessApp()) {
    return popToastMsgNess(input_el, type, opt);
  }
  return createPopToastMsgForMarppleShop()(input_el, type, opt);
};

const popToastMsgNess = (input_el, type, opt) => {
  if (!toast_container_el) toast_container_el = initToastContainer();
  if (!toast_container_el.parentNode) $appendTo(document.body, toast_container_el);

  const item_el = input_el instanceof HTMLElement ? input_el : createToastMsg(type, input_el, opt);

  $prependTo(toast_container_el, item_el);
  setTimeout(() => {
    $addClass(end_class, item_el);
  }, 2500);
};
